import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Feed } from 'src/app/models/Feed';
import { Reaction } from 'src/app/models/Reaction';
import { AuthService } from 'src/app/services/auth.service';
import { FeedService } from 'src/app/services/modelService/feed.service';
import { ReactionService } from 'src/app/services/modelService/reaction.service';

@Component({
  selector: 'app-feed-card',
  templateUrl: './feed.component.html',
  styleUrls: ['./feed.component.scss'],
})
export class FeedComponent implements OnInit {
  @Input() feed: Feed = new Feed();
  @Output() openDetails = new EventEmitter<string>();
  showEmojiBox = false;
  constructor(public reactionService: ReactionService, private feedService: FeedService, private auth: AuthService) { }

  ngOnInit() {
    this.auth.getLoggedInEmployee();

  }
  
  clickEmoji(emoji) {
    this.showEmojiBox = false;
    this.reactionService.reaction.reaction = emoji;
    console.log(this.reactionService.reaction);
    this.feedService.sendMessage(this.feed);
  }
}
